/** Legacy cache shape — keep `['addresses', customer_id]` and `['areas']` during WIRE. */
export const addressesQueryKey = ['addresses'] as const;
export const areasQueryKey = ['areas'] as const;
